export {default} from './InputComponent';